import { Alert, Button, ButtonGroup, Text } from '@chakra-ui/react';
import { Modal } from '@gamma/ui/overlay';
import { i18n } from '@investigator/shared/localization';
import { useEntitiesContext, SuppressionAction } from '../../context';

const { excludeEntity } = i18n.pages.entityDetails;
const {
  suppress,
  unSuppress,
  cancel,
  willNotReceiveAlerts,
  willReceiveAlerts,
} = excludeEntity;

export const EntitySuppressionModal = (): JSX.Element => {
  const {
    selectedEntity,
    suppressionModal: { isOpen, onClose },
    suppression,
  } = useEntitiesContext();

  const isSuppressed = selectedEntity?.entityIsSuppressed;
  const title = isSuppressed ? unSuppress : suppress;

  const handleConfirm = async () => {
    const action = isSuppressed
      ? SuppressionAction.UNSUPPRESS
      : SuppressionAction.SUPPRESS;
    await suppression.updateSuppression(action);
    onClose();
  };
  const suppressedMessage = isSuppressed
    ? `Are you sure you want to unsuppress ${selectedEntity?.entityName}?`
    : `Are you sure you want to suppress ${selectedEntity?.entityName}?`;

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      body={
        <>
          <Text mb={2}>{suppressedMessage}</Text>
          <Alert variant="subtle" status="warning">
            {isSuppressed ? willReceiveAlerts : willNotReceiveAlerts}
          </Alert>
        </>
      }
      footer={
        <ButtonGroup>
          <Button variant="solid" colorScheme="gray" onClick={onClose}>
            {cancel}
          </Button>
          <Button
            variant="solid"
            colorScheme="blue"
            isLoading={suppression.pendingUpdate}
            data-testid="suppress-entity-submit"
            onClick={handleConfirm}
          >
            {isSuppressed ? unSuppress : suppress}
          </Button>
        </ButtonGroup>
      }
    />
  );
};
